<template>
    <div class="login">
        <div class="login-form">
            <input type="email" placeholder="Логин" v-model="email" />
            <input type="password" placeholder="Пароль" v-model="password" />
            <div class="button"
                 :class="{disabled: $store.getters['auth/authStatus'] == 'loading'}"
                 @click="login()"><span>Войти</span>
                <img src="~@/assets/img/preloader-white.svg" v-show="$store.getters['auth/authStatus'] == 'loading'" class="preloader">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                email: '',
                password: ''
            }
        },
        methods: {
            login () {
                this.$store.commit('auth/auth_request')
                this.axios({url: 'login', data: 'email=' + this.email + '&password=' + this.password, method: 'POST' })
                    .then(resp => {
                        //const token = resp.data.token
                        let user = resp.data
                        this.$store.commit('auth/auth_success', user)
                        this.$router.push('/parking')
                    }).catch(() => {
                        let msg = {
                            message: 'User not found!',
                            status: 'error'
                        }
                        this.$store.dispatch('utils/showMessage', msg)
                        this.$store.commit('auth/auth_error')
                    })
            }
        }
    }
</script>